<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="file-protect" nzTheme="outline"></i> Select Insured</h3>
</div>
<div class="search-results m-t-20">
  <nz-table #clientSearchTable [nzData]="insuredList" [nzShowPagination]="false">
    <thead>
      <tr>
        <th>Selected</th>
        <th>Client Number</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Date Of Birth</th>
        <th>Gender</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of clientSearchTable.data">
        <!-- <td>< nz-radio [nzValue]="data.clientNum" [(ngModel)]="radioValue" name="radioValue"> -->
        <td>
          <!-- <input type="radio" name="test" value="{{data.id}}" (change)="handleChange($event,data.id)" [(ngModel)]="radioValue" > -->
          <label nz-checkbox [(ngModel)]="data['selected']" (ngModelChange)="deselectOtherClients(data)"></label>
        </td>
        <td>{{data.clientNum}}</td>
        <td>{{data.firstName}}</td>
        <td>{{data.lastName}}</td>
        <td>{{getDateString(data.dateOfBirth)}}</td>
        <td>{{(data.genderCd | technicalTranslate) || ''}}</td>
      </tr>

    </tbody>
  </nz-table>
</div>